import React from 'react';
import Moment from 'react-moment';
import Grid from '@material-ui/core/Grid';
import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => createStyles({
  root: {
    margin: '10px 0',
  },
  content: {
    border: '1px solid #dbdbdb',
    padding: '20px',
  },
  textRight: {
    textAlign: 'right',
  },
}));

export default function ReportCardsDetailsComment(props) {
  const classes = useStyles();
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });
  const {
    data,
    onDeleteClick,
    onEditClick,
  } = props;

  const onDeleteLinkClick = (event) => {
    event.preventDefault();

    onDeleteClick(data)
  };

  const onEditLinkClick = (event) => {
    event.preventDefault();

    onEditClick(data);
  };

  return (
    <div className={`report-cards-details-comment ${classes.root}`}>
      <div className={classes.content}>{data.description}</div>
      <Grid container className={classes.footer}>
        <Grid item xs={6}>
          {data.parent_name && (
            <small>{data.parent_name} - </small>
          )}
          <small><Moment format={dateFormat + ' HH:mm'}>{data.date}</Moment></small>
        </Grid>
        <Grid item xs={6} className={classes.textRight}>
          {data.can_edit && (
            <>
              <a href="#" onClick={onDeleteLinkClick}>{t('Delete')}</a>
              <span> | </span>
              <a href="#" onClick={onEditLinkClick}>{t('Edit')}</a>
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
